import { createI18n } from "vue-i18n";
// import i18n from './locales/i18n.json'
import merge from "deepmerge";
import { useI18n } from "vue-i18n";
import { LocalStore } from "@gd/storage";
import { DateFormat } from "./DateFormat";
/**
 * maps viewLang and viewCountry to $i18n.locale
 */
const mapLang = {
    "en-US": "en",
    "en-GB": "en-GB",
    "nl-NL": "nl",
    "sv-SE": "sv",
    "da-DK": "da",
    "de-DE": "de",
    "de-AT": "de",
    "es-ES": "es",
    "es-US": "es",
    "fr-FR": "fr",
};
// such in case the country is not available we choose them from the countryMap
const countryMap = {
    en: "US",
    "en-GB": "GB",
    nl: "NL",
    sv: "SE",
    da: "DK",
    de: "DE",
    // fallback won't work anymore with es-US and en-US
    es: "ES",
    fr: "FR",
};
let init = false;
const storage = new LocalStore({});
function loadLocaleMessages() {
    // not nice but webpack requires to pass the folder as string literal - variables are not allowed
    // the alternative to this is to move out the required.context call to the parent component and pass
    // the locales as parameter.
    // path out: ./node_modules/@gd/i18n/dist/
    // path in: ./src/locales/
    const locales = require.context("../../../../src/locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages = {};
    locales.keys().forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1].split("_")[1];
            if (locale) {
                // TODO - find out when it's default and when it's not
                messages[locale] = locales(key).default || locales(key);
                if (locale === "de") {
                    messages["de-AT"] = locales(key);
                }
            }
        }
    });
    const i18n = locales("./i18n.json");
    if (i18n) {
        ;
        messages["none"] = i18n.default;
    }
    return messages;
}
/**
 * use this method to setup i18n in components - it expects the locale files be loaded from ./src/locales.
 *
 * @param setupI18n
 * @returns useI18n(...)
 */
function setupComponentI18n(setupI18n) {
    if (init === true && setupI18n?.useScope !== "local") {
        return useI18n({ useScope: setupI18n?.useScope || "global" });
    }
    init = true;
    // we can limit the scope to not overwrite keys in other components with: {useScope: 'local'}
    // the huge disadvantage here is that the scope of "local" is only available in "this" component (no parent, no children).
    // This can be very unpracticable because no other component has access to this keys.
    // If you can't use "local" (either parent (use scope of parent component) or global) then your messageKey must
    // be kind of unique to not overwrite other component keys
    const i18n = useI18n({ useScope: setupI18n?.useScope || "global" });
    const componentMessages = loadLocaleMessages();
    Object.keys(componentMessages).forEach((lang) => {
        if (!componentMessages[lang]) {
            console.warn(`i18n whoops. Can not find message bundle for lang ${lang}`);
        }
        const obj = merge(i18n.messages.value[lang] || {}, componentMessages[lang] || {});
        i18n.setLocaleMessage(lang, obj);
    });
    return i18n;
}
export { setupComponentI18n };
export { DateFormat };
/**
 * web export for createApp(...).use(i18n)
 */
export default createI18n({
    locale: mapLang[(storage.gd.viewLang &&
        storage.gd.viewLang +
            "-" +
            // fallback won't work anymore with es-US and en-US
            (storage.gd.viewCountry || countryMap[storage.gd.viewLang])) ||
        "en-US"],
    legacy: false,
    fallbackLocale: "en-US",
    messages: loadLocaleMessages(),
    datetimeFormats: {
        // For endless possibilities to format,
        // see http://www.ecma-international.org/ecma-402/2.0/#sec-intl-datetimeformat-constructor
        de: {
            [DateFormat.MMHHDDMMYYY]: {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
            },
            [DateFormat.DDMMYYY]: {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            },
            [DateFormat.MMHH]: {
                hour: "2-digit",
                minute: "2-digit",
            },
        },
        en: {
            [DateFormat.MMHHDDMMYYY]: {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
            },
            [DateFormat.DDMMYYY]: {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            },
            [DateFormat.MMHH]: {
                hour: "2-digit",
                minute: "2-digit",
            },
        },
    },
    silentTranslationWarn: process.env.NODE_ENV === "development", // YES, you may want to take this out again
});
//# sourceMappingURL=index.js.map